module.exports = __webpack_public_path__ + "img/section4.6e6d3184.png";